/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuTypeahead_viewer = {
    readonly itemFacetSearch?: {
        readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuSearchResults_itemFacetSearch">;
    } | null;
    readonly " $refType": "SbSharedRefineMenuTypeahead_viewer";
};
export type SbSharedRefineMenuTypeahead_viewer$data = SbSharedRefineMenuTypeahead_viewer;
export type SbSharedRefineMenuTypeahead_viewer$key = {
    readonly " $data"?: SbSharedRefineMenuTypeahead_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuTypeahead_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "facetName"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "hasQuery"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchString"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "uriRef"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuTypeahead_viewer",
  "selections": [
    {
      "condition": "hasQuery",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "countryCode",
              "variableName": "userCountryCode"
            },
            {
              "kind": "Variable",
              "name": "facetName",
              "variableName": "facetName"
            },
            {
              "kind": "Variable",
              "name": "searchString",
              "variableName": "searchString"
            },
            {
              "kind": "Variable",
              "name": "uriRef",
              "variableName": "uriRef"
            }
          ],
          "concreteType": "ItemFacetsQueryConnection",
          "kind": "LinkedField",
          "name": "itemFacetSearch",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SbSharedRefineMenuSearchResults_itemFacetSearch"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '530a07ed88673e669bd12b5ee32981f9';
export default node;
